function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.890625 5.64062L1.33594 6.10938C1.45312 6.22656 1.64062 6.22656 1.73438 6.10938L5.39062 2.47656V10.4688C5.39062 10.6328 5.50781 10.75 5.67188 10.75H6.32812C6.46875 10.75 6.60938 10.6328 6.60938 10.4688V2.47656L10.2422 6.10938C10.3359 6.22656 10.5234 6.22656 10.6406 6.10938L11.0859 5.64062C11.2031 5.54688 11.2031 5.35938 11.0859 5.24219L6.1875 0.34375C6.07031 0.226562 5.90625 0.226562 5.78906 0.34375L0.890625 5.24219C0.773438 5.35938 0.773438 5.54688 0.890625 5.64062Z",
  fill: "#2DC08E"
});

var SvgIndexUpIconDark = function SvgIndexUpIconDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIndexUpIconDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IndexUpIconDark.975685c2.svg";
export { ForwardRef as ReactComponent };